import { render, staticRenderFns } from "./requestOver.vue?vue&type=template&id=45785034&"
import script from "./requestOver.vue?vue&type=script&lang=js&"
export * from "./requestOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45785034')) {
      api.createRecord('45785034', component.options)
    } else {
      api.reload('45785034', component.options)
    }
    module.hot.accept("./requestOver.vue?vue&type=template&id=45785034&", function () {
      api.rerender('45785034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/requestOver.vue"
export default component.exports